module.exports = __webpack_public_path__ + "static/designEditBackGround-3401460933fb54fba720cab4b070f5a9.png";